/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ServiceAccountsControllerGetApiSettingsQueryResponse, ServiceAccountsControllerGetApiSettingsPathParams, ServiceAccountsControllerGetApiSettings400, ServiceAccountsControllerGetApiSettings401, ServiceAccountsControllerGetApiSettings403, ServiceAccountsControllerGetApiSettings404 } from "../../models/serviceAccountsController/ServiceAccountsControllerGetApiSettings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { serviceAccountsControllerGetApiSettings } from "../../clients/service-accountsService/serviceAccountsControllerGetApiSettings";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const serviceAccountsControllerGetApiSettingsQueryKey = (orgId: ServiceAccountsControllerGetApiSettingsPathParams["orgId"]) => [{
  url: '/api/v1/organizations/:orgId/api-settings',
  params: {
    orgId: orgId
  }
}] as const;
export type ServiceAccountsControllerGetApiSettingsQueryKey = ReturnType<typeof serviceAccountsControllerGetApiSettingsQueryKey>;
export function serviceAccountsControllerGetApiSettingsQueryOptions(orgId: ServiceAccountsControllerGetApiSettingsPathParams["orgId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = serviceAccountsControllerGetApiSettingsQueryKey(orgId);
  return queryOptions<ServiceAccountsControllerGetApiSettingsQueryResponse, ResponseErrorConfig<ServiceAccountsControllerGetApiSettings400 | ServiceAccountsControllerGetApiSettings401 | ServiceAccountsControllerGetApiSettings403 | ServiceAccountsControllerGetApiSettings404>, ServiceAccountsControllerGetApiSettingsQueryResponse, typeof queryKey>({
    enabled: !!orgId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return serviceAccountsControllerGetApiSettings(orgId, config);
    }
  });
}

/**
 * @summary Read the organization API version pin, supported versions and active-key limit
 * {@link /api/v1/organizations/:orgId/api-settings}
 */
export function useServiceAccountsControllerGetApiSettings<TData = ServiceAccountsControllerGetApiSettingsQueryResponse, TQueryData = ServiceAccountsControllerGetApiSettingsQueryResponse, TQueryKey extends QueryKey = ServiceAccountsControllerGetApiSettingsQueryKey>(orgId: ServiceAccountsControllerGetApiSettingsPathParams["orgId"], options: {
  query?: Partial<QueryObserverOptions<ServiceAccountsControllerGetApiSettingsQueryResponse, ResponseErrorConfig<ServiceAccountsControllerGetApiSettings400 | ServiceAccountsControllerGetApiSettings401 | ServiceAccountsControllerGetApiSettings403 | ServiceAccountsControllerGetApiSettings404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? serviceAccountsControllerGetApiSettingsQueryKey(orgId);
  const query = useQuery({
    ...serviceAccountsControllerGetApiSettingsQueryOptions(orgId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ServiceAccountsControllerGetApiSettings400 | ServiceAccountsControllerGetApiSettings401 | ServiceAccountsControllerGetApiSettings403 | ServiceAccountsControllerGetApiSettings404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}